import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

import './Skeleton.scss';

export type SkeletonProps = {
    count?: number;
    circle?: boolean;
    style?: React.CSSProperties;
    className?: string;
};

export const SkeletonComponent: React.FC<SkeletonProps> = ({ count = 1, circle = false, style, className }) => {
    return <Skeleton count={count} circle={circle} style={style} className={className} />;
};
